import { Component, OnInit, ViewChild } from '@angular/core';
import { GeneralExerciseComponent } from '../../General/g-exercise.component';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from '../../shared/message.service';
import { TopicService } from '../topic.service';
import { ImageEditorComponent } from '../image-editor/image-editor.component';

@Component({
  selector: 'app-image-compression',
  templateUrl: './image-compression.component.html',
  styleUrls: ['./image-compression.component.css']
})
export class ImageCompressionComponent extends GeneralExerciseComponent {

  @ViewChild('imageEditor', {static:true}) imageEditor: ImageEditorComponent;

  largeImage: string[][];
  image: string[][];

  colors: string;
  highlight: boolean;

  errors: number[][] = [];

  current: number[] = [0,0];

  constructor(activatedRoute: ActivatedRoute, topicService: TopicService, messageService: MessageService) {
    super(activatedRoute, topicService, messageService)
  }

  setTypeSpecificsFromConfiguration() {
    this.largeImage = this.configuration.typespecifics.image;
    this.colors = this.configuration.typespecifics.colors;
    this.highlight = this.configuration.typespecifics.highlight;
    this.imageEditor.initImage(true);
    this.image = undefined;
    console.log(this.imageEditor.getImage());
    
    this.printable = true;
  }

  setTypeSpecificsFromState() {
    if (this.state.typespecific) {
      if (this.state.typespecific.image) {
        this.image = this.state.typespecific.image;
        this.imageEditor.setImage(this.image);
      }
    }
  }

  computeState() {
    this.state.typespecific.image = this.imageEditor.getImage();
  }

  checkSolution() {
    let solution = this.compressedImage();
    this.image = this.imageEditor.getImage();
    let temp_errors = this.image.map((v,i) => v.map((u,j) => [u,i,j]).filter(u => u[0] != solution[+u[1]][+u[2]]).map(u => [+u[1],+u[2]]));
    this.errors = [].concat(...temp_errors);
    if(this.errors.length > 0){
      this.messageService.addAlertWithTimeout(this.get("notCorrectYet"), "danger", 10000);
    } else {
      this.messageService.addAlertWithTimeout(this.get("correct"), "success", 10000);
      this.state.solved = true;
      this.solved = true;
      this.saveState();
    }
  }

  evaluate(): number[] {
    let points = this.colors=="bw"?3:5;
    let solution = this.compressedImage();
    this.image = this.imageEditor.getImage();
    let temp_errors = this.image.map((v,i) => v.map((u,j) => [u,i,j]).filter(u => u[0] != solution[+u[1]][+u[2]]).map(u => [+u[1],+u[2]]));
    temp_errors = [].concat(...temp_errors);
    console.log(points*(400-temp_errors.length)/400);
    return [points*(400-temp_errors.length)/400, points];
  }

  /** returns the expanded name for the color abbreviation */
  color(c: string) {
    switch (c) {
      case "k": return "black";
      case "c": return "cyan";
      case "m": return "magenta";
      case "y": return "yellow";
      case "r": return "red";
      case "g": return "green";
      case "b": return "blue";
      default: return "white";
    }
  }

  /** is the given pixel currently selected?  */
  inCurrent(i: number, j:number):boolean{
    return (Math.floor(i/2) == this.current[0] && Math.floor(j/2) == this.current[1]);
  }

  /** is the given pixel erroreous? */
  inError(i: number, j: number):boolean{

    for(let e of this.errors){
      if(Math.floor(i/2) == e[0] && Math.floor(j/2) == e[1]){
        return true;
      }
    }
    return false;
  }


  /** returns the compressed image */
  compressedImage(): string[][]{
    let image = [];
    for(let i = 0; i < 10; i++){
      let row = [];
      for(let j = 0; j < 10; j++){
        let square = [];
        square.push(this.largeImage[i*2][j*2]);
        square.push(this.largeImage[i*2+1][j*2]);
        square.push(this.largeImage[i*2][j*2+1]);
        square.push(this.largeImage[i*2+1][j*2+1]);
        if(this.colors == "bw"){
          square = square.filter(v => v=="k");
          if(square.length >= 2){
            row.push("k");
          } else {
            row.push("w");
          }
        } else {
          if(square.includes('c') && square.includes('m') && square.includes('y')){
            row.push("k");
          } else if(square.includes('c') && square.includes('y')){
            row.push("g");
          } else if(square.includes('c') && square.includes('m')){
            row.push("b");
          } else if(square.includes('y') && square.includes('m')){
            row.push("r");
          } else if(square.includes('c')){
            row.push("c");
          } else if(square.includes('m')){
            row.push("m");
          } else if(square.includes('y')){
            row.push("y");
          } 
        }
      }
      image.push(row);
    }

    return image;
  }


}
